import {request} from "./request";


export function GetNewsListByType(type) {
  return request({
    url: 'news/NewsListByType',
    params: {
      type
    }
  })
}

export function GetNewsById(id) {
  return request({
    url: 'news/NewsById',
    params: {
      id
    }
  })
}

export function AddNews(nType, title, src, des, img, content, uTime) {
  return request({
    url: 'news/AddNews',
    params: {
      nType, title, src, des, img, content, uTime
    }
  })
}

export function DelNewsById(id) {
  return request({
    url: 'news/DelNewsById',
    params: {
      id
    }
  })
}

export function GetSwiperList(id) {
  return request({
    url: 'swiper/GetSwiperList',
    params: {
      id
    }
  })
}
